<template>
    <!-- <div>
      <img :src="verdeImage" alt="Mindef Image">
    </div> -->
    <v-sheet color="blue-darken-4" elevation="10" max-width="600" rounded="lg" width="100%"
      class="pa-4 text-center mx-auto">
      <center><v-img src="@/assets/mindef1.jpg" alt="Imagen" class="img" max-height="110" width= 340 style="border-radius: 15px; box-shadow: 0px 0px 10px rgba(0,0,0,5);"></v-img></center>
       <br><h2 class="text-h5 mb-1">REPORTE DOTACION PISTOLA POR FUERZA</h2>
    </v-sheet>
    <div>
  
      <v-card class="mx-auto my-3"
      max-width="100%"
      elevation="10">
        <v-sheet max-width="350" class="mx-left pa-3">
  
  <v-form @submit.prevent>
    <!-- <v-text-field label="GRADO" v-model="valorCampo1"></v-text-field> -->
    <v-select v-model="valorCampo1" label="TIPO DE GRADO"
      :items="['OFICIALES','SUBOFICIALES']" variant="outlined"></v-select>
    <v-select v-model="valorCampo3" label="FUERZA" :items="['EJERCITO', 'FUERZA AEREA', 'FUERZA ARMADA']" variant="outlined"></v-select>
    <v-btn @click="buscar" append-icon="mdi-magnify" type="submit" color="blue-darken-4" block
      class="mt-2 font-weight-bold">CONSULTAR</v-btn>
  
  </v-form>
  </v-sheet>
      </v-card>
      <v-card class="mx-auto my-3"
      max-width="100%"
      elevation="10">
        <v-card-title class="d-flex align-center pe-2">
          <v-icon icon="mdi-video-input-component"></v-icon> &nbsp;
          Lista de Busquedas
          <v-spacer></v-spacer>
          <v-btn @click="generarPDF" color="red" type="submit" class="mt-2 font-weight-bold"><v-icon>mdi-file-pdf-box</v-icon>REPORTE PDF</v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" density="compact" label="Busqueda" single-line
            flat hide-details variant="solo-filled"></v-text-field>
        </v-card-title>
  
        <v-divider></v-divider>
        <v-data-table :headers="headers" :items="registros" :search="search" style="background-color: #ECEFF1;">
        </v-data-table>
  
      </v-card>
    </div>
  </template>
  <script>
  import pdfMake from "pdfmake/build/pdfmake";
  import { defineComponent } from "vue";
  import { VDataTable } from "vuetify/labs/VDataTable";
  import ReportesRegistro from "@/services/Reportes";
  export default defineComponent({
    components: {
      VDataTable,
    },
    data() {
      var registros;
      const reportes = new ReportesRegistro();
      
      return {
        search: "",
        registros,
        reportes,
        valorCampo1: "",
        valorCampo3: "",
  
        headers: [
          /* {
            align: "center",
            key: "name",
            sortable: true,
          }, */
          { key: "num", title: "#", align: "center"},
          /* { key: "num", title: "#", sortable: true, width: 50}, */
          { key: "grado", title: "GRADO", align: "left" },
          { key: "nombre_completo", title: "NOMBRE COMPLETO", align: "left" },
          { key: "carnet", title: "CARNET", align: "left" },
        ],
      }
    },
    methods: {
      convertirImagenDataURL(imagen) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
  
          // Cargar la imagen como un Blob
          fetch(imagen)
            .then(response => response.blob())
            .then(blob => {
              reader.readAsDataURL(blob); // Convertir la imagen en una URL de datos
            })
            .catch(error => {
              reject(error);
            });
        });
      },
  
      async buscar() {
        this.registros = await this.reportes.busquedapistolafuerza(this.valorCampo1, this.valorCampo3);
      },
      async generarPDF() {
        // Verificar si hay datos para generar el PDF
        if (this.registros.length === 0) {
          alert("No hay datos para generar el PDF");
          return;
        }
  
        // Cargar la imagen como un recurso
        const imagenRecurso = await import('@/assets/images/mindef.jpg');
  
        // Convertir la imagen en una URL de datos
        const imagenDataURL = await this.convertirImagenDataURL(imagenRecurso.default);
  
        // Mapear los registros a un formato adecuado para pdfMake
        const pdfRows = this.registros.map((item, index) => {
          return [
            index + 1, // Añade numeración ascendente, comenzando en 1
            item.grado || '',
            item.nombre_completo || '',
            item.carnet || ''
          ];
        });
        const currentDate = new Date();
        const formattedDate = new Intl.DateTimeFormat('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).format(currentDate);
  
        const fechaHora = `FECHA: ${formattedDate}`;
        // Definir la estructura del documento PDF
        const documentDefinition = {
          content: [
            //IMAGEN CABECERA
            {
              image: imagenDataURL, // Usar la URL de datos de la imagen
              width: 200, // ajusta el ancho según tus necesidades
              alignment: "left", // ajusta la alineación según tus necesidades
              margin: [0, 0, 0, 0],  // Ancho de la imagen en el PDF
            },
            {
              text: fechaHora, // Agregar la fecha y hora con el formato deseado
              alignment: 'left', // Alinear la fecha y hora a la derecha
              fontSize: 8,
              margin: [0, 5, 0, 0],
            },
            {
              text: `FUERZA: ${this.valorCampo3}`, // Agregar la fecha y hora con el formato deseado
              alignment: 'left', // Alinear la fecha y hora a la derecha
              fontSize: 8,
              margin: [0, 5, 0, 0],
            },
            { text: `REPORTE DE DOTACIÓN DE PISTOLAS `, style: "header",fontSize: 10, },
            /* { text: "Datos obtenidos:", style: "subheader" }, */
            {
              table: {
                headerRows: 1,
                widths: ['auto', 'auto', 'auto', '*'],
                body: [
                  [
                    { text: '#', fillColor: '#01579B', bold: true, color: 'white', alignment: 'center', },
                    { text: 'GRADO', fillColor: '#01579B', bold: true, color: 'white', alignment: 'center', },
                    { text: 'NOMBRE_COMPLETO', fillColor: '#01579B', bold: true, color: 'white', alignment: 'center', },
                    { text: 'CARNET', fillColor: '#01579B', bold: true, color: 'white', alignment: 'center', }
                  ],
                  ...pdfRows
                ]
              },
              fontSize: 8,
            }
          ],
          footer: function (currentPage, pageCount) {
            return {
              table: {
                widths: ['*', 'auto'],
                body: [
                  [
                    { text: 'UNIDAD DE SISTEMAS E INFORMÁTICA GESTIÓN 2024', fontSize: 8, alignment: 'left' },
                    { text: `Pag. ${currentPage}/${pageCount}`, fontSize: 8, alignment: 'right' }
                  ]
                ]
              },
              layout: 'noBorders', // Para eliminar los bordes de la tabla
              margin: [40, 10] // Margen izquierdo y derecho para centrar la tabla
            };
          },
          styles: {
            header: { fontSize: 18, alignment: "center", bold: true, margin: [0, 0, 0, 10] },
            subheader: { fontSize: 16, bold: true, margin: [0, 10, 0, 5] },
          },
        };
  
        // Generar y abrir el PDF
        pdfMake.createPdf(documentDefinition).open();
      },
    },
    async created() {
      this.registros = await this.reportes.busquedapistolafuerza();
  
    },
  
  
  });
  
  </script>